import React, { useState } from "react";
import { Dropdown, DropdownButton, Form } from "react-bootstrap";
import clx from "classnames";
const styles = require("./styles.scss");
const Select = ({ onChange, selectOptions }) => {
    const [paginationSize, setPaginationSize] = useState("10");
    const setPagination = (value) => {
        setPaginationSize(value);
        onChange({ PageSize: Number(value), PageNumber: 1 });
    };
    return (React.createElement("div", { className: clx(styles.itemsSelectWrapper) },
        React.createElement(Form.Label, null, "Items per page:"),
        React.createElement(DropdownButton, { id: "set-pagination", title: paginationSize, variant: "secondary" }, selectOptions.map(option => (React.createElement(Dropdown.Item, { key: `optione${option}`, eventKey: `${option}`, onSelect: setPagination, active: Number(paginationSize) === option }, option))))));
};
export default Select;
